import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
  closeButton: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "8px",
  },
});

const CustomDrawer = ({
  anchor = "right",
  children,
  buttonLabel = "Open Drawer",
  customClass = "custom",
  drawerClass,
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (isOpen) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpen(isOpen);
  };

  return (
    <div className={customClass}>
      <Button onClick={toggleDrawer(true)}>{buttonLabel}</Button>
      <Drawer
        anchor={anchor}
        open={open}
        onClose={toggleDrawer(false)}
        className={drawerClass}
      >
        <div
          className={clsx(classes.list, {
            [classes.fullList]: anchor === "top" || anchor === "bottom",
          })}
          role="presentation"
        >
          <div className={classes.closeButton}>
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </div>
          {children}
        </div>
      </Drawer>
    </div>
  );
};

export default CustomDrawer;
